import { Box } from '@chakra-ui/react';
import React from 'react';

import { PortfolioSummaryChartContainer } from './PortfolioSummaryChartContainer';
import {
  Dashboard,
  PortfolioSummaryOverviewCards,
} from './PortfolioSummaryOverviewCards';

export const PortfolioSummaryContainer: React.FC<{
  capitalProviderOrganizationIds: string[];
  creditFacilityId: string;
  dashboard: Dashboard;
}> = ({ capitalProviderOrganizationIds, creditFacilityId, dashboard }) => {
  return (
    <Box>
      <PortfolioSummaryOverviewCards
        capitalProviderOrganizationIds={capitalProviderOrganizationIds}
        creditFacilityId={creditFacilityId}
        dashboard={dashboard}
      />
      <PortfolioSummaryChartContainer creditFacilityId={creditFacilityId} />
    </Box>
  );
};
